export default __webpack_public_path__ + "39ac55a8fce6a116f8434e2daa286d89.svg";